/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface Approve$Request {
    changeRequestId: number;
}

export interface Approve$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const approveRequest = createAction<PayloadData<void, Approve$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__APPROVE__REQUEST');
export const approveSuccess = createAction<PayloadData<void, Approve$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__APPROVE__SUCCESS');
export const approveFailure = createAction<PayloadData<Error, Approve$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__APPROVE__FAILURE');

export const approveActions = [
    approveRequest,
    approveSuccess,
    approveFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const approve = (meta: Approve$Request, config?: Approve$Config) => {
    return {
        CALL_API: {
            types: approveActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/approve/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface Reject$Request {
    changeRequestId: number;
}

export interface Reject$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const rejectRequest = createAction<PayloadData<void, Reject$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__REJECT__REQUEST');
export const rejectSuccess = createAction<PayloadData<void, Reject$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__REJECT__SUCCESS');
export const rejectFailure = createAction<PayloadData<Error, Reject$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__REJECT__FAILURE');

export const rejectActions = [
    rejectRequest,
    rejectSuccess,
    rejectFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const reject = (meta: Reject$Request, config?: Reject$Config) => {
    return {
        CALL_API: {
            types: rejectActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/reject/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface Reopen$Request {
    changeRequestId: number;
}

export interface Reopen$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const reopenRequest = createAction<PayloadData<void, Reopen$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__REOPEN__REQUEST');
export const reopenSuccess = createAction<PayloadData<void, Reopen$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__REOPEN__SUCCESS');
export const reopenFailure = createAction<PayloadData<Error, Reopen$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__REOPEN__FAILURE');

export const reopenActions = [
    reopenRequest,
    reopenSuccess,
    reopenFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const reopen = (meta: Reopen$Request, config?: Reopen$Config) => {
    return {
        CALL_API: {
            types: reopenActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/reopen/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendToApprove$Request {
    changeRequestId: number;
}

export interface SendToApprove$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendToApproveRequest = createAction<PayloadData<void, SendToApprove$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__SEND_TO_APPROVE__REQUEST');
export const sendToApproveSuccess = createAction<PayloadData<void, SendToApprove$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__SEND_TO_APPROVE__SUCCESS');
export const sendToApproveFailure = createAction<PayloadData<Error, SendToApprove$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__SEND_TO_APPROVE__FAILURE');

export const sendToApproveActions = [
    sendToApproveRequest,
    sendToApproveSuccess,
    sendToApproveFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendToApprove = (meta: SendToApprove$Request, config?: SendToApprove$Config) => {
    return {
        CALL_API: {
            types: sendToApproveActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/send-to-approve/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SendToReview$Request {
    changeRequestId: number;
}

export interface SendToReview$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const sendToReviewRequest = createAction<PayloadData<void, SendToReview$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__SEND_TO_REVIEW__REQUEST');
export const sendToReviewSuccess = createAction<PayloadData<void, SendToReview$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__SEND_TO_REVIEW__SUCCESS');
export const sendToReviewFailure = createAction<PayloadData<Error, SendToReview$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__SEND_TO_REVIEW__FAILURE');

export const sendToReviewActions = [
    sendToReviewRequest,
    sendToReviewSuccess,
    sendToReviewFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const sendToReview = (meta: SendToReview$Request, config?: SendToReview$Config) => {
    return {
        CALL_API: {
            types: sendToReviewActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/send-to-review/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StartReview$Request {
    changeRequestId: number;
}

export interface StartReview$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const startReviewRequest = createAction<PayloadData<void, StartReview$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__START_REVIEW__REQUEST');
export const startReviewSuccess = createAction<PayloadData<void, StartReview$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__START_REVIEW__SUCCESS');
export const startReviewFailure = createAction<PayloadData<Error, StartReview$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__START_REVIEW__FAILURE');

export const startReviewActions = [
    startReviewRequest,
    startReviewSuccess,
    startReviewFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const startReview = (meta: StartReview$Request, config?: StartReview$Config) => {
    return {
        CALL_API: {
            types: startReviewActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/start-review/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopReview$Request {
    changeRequestId: number;
}

export interface StopReview$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopReviewRequest = createAction<PayloadData<void, StopReview$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__STOP_REVIEW__REQUEST');
export const stopReviewSuccess = createAction<PayloadData<void, StopReview$Request>>('CHANGE_REQUEST_STATUS_CONTROLLER__STOP_REVIEW__SUCCESS');
export const stopReviewFailure = createAction<PayloadData<Error, StopReview$Request, true>>('CHANGE_REQUEST_STATUS_CONTROLLER__STOP_REVIEW__FAILURE');

export const stopReviewActions = [
    stopReviewRequest,
    stopReviewSuccess,
    stopReviewFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopReview = (meta: StopReview$Request, config?: StopReview$Config) => {
    return {
        CALL_API: {
            types: stopReviewActions,
            method: ApiMethods.POST,
            endpoint: `/change-request-statuses/stop-review/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

